import { formatDate } from '@utils';

const handleJobAssigneeName = (jobUserEmail = '', assignees = []) => {
  if (!jobUserEmail) {
    return '';
  }

  if (jobUserEmail === 'system') {
    return 'System';
  }

  const user = assignees.find((assignee) => assignee.email === jobUserEmail);

  if (!!user && !!user.text) {
    return user.text;
  }
  if (user?.email) {
    return user.email;
  }
  return 'Unknown User';
};

export const handleExportDataJobsData = (jobs = [], assignees = []) => {
  if (!jobs.length) {
    return [];
  }

  const newJobs = jobs.map((job) => {
    return {
      ...job,
      createdBy: handleJobAssigneeName(job.createdBy, assignees),
      createdAt: job.createdAt
        ? formatDate(job.createdAt, 'dd/MM/yyyy HH:mm')
        : '-',
    };
  });

  return newJobs;
};
